import { Box, Tooltip } from '@mui/material'
import LaunchRoundedIcon from '@mui/icons-material/LaunchRounded'
import { useSearchContext } from '../../context/SearchCacheContext'
import { useColorModeContext } from '../../context/ColorModeContext'
import { classNames } from '../../utils/Utils'
import { Link } from 'react-router-dom'

const TrackingKeywordUrl = ({ data }) => {
  const { mode } = useColorModeContext()
  const { country, setCountry, setInputValue } = useSearchContext()

  if (!data || !data.history || data.history.length === 0 || !data.history[data.history.length - 1]) {
    return
  }

  const mostRecentHistory = data.history[data.history.length - 1]
  const url = mostRecentHistory.url
  const urlWithoutDomain = (url ? url.replace(/^https?:\/\/[^/]+\//, '').replace(/\/$/, '') : '') || '/'
  const MAX_VISIBLE_CHARACTERS = 50

  const handleLinkClick = () => {
    setInputValue(data.keyword)
    setCountry(country)
  }

  return (
    <Box sx={{ display: 'flex', mt: 1 }}>
      <div className='KeywordRedirectLink'>
        <Tooltip title={url} arrow followCursor>

          <Link to={`/keywords/explorer/?q=${data.keyword}&country=${country}`} relative='path' replace onClick={handleLinkClick} className={classNames(mode)}>
            {urlWithoutDomain.length > MAX_VISIBLE_CHARACTERS ? `${urlWithoutDomain.substring(0, MAX_VISIBLE_CHARACTERS)}...` : urlWithoutDomain}
          </Link>
        </Tooltip>
        <a
          target='_blank' href={`${url}`} rel='noopener noreferrer'
          className={classNames('btn-link keywordLinkBlank', mode)}
        >
          <div>
            <span />
            <LaunchRoundedIcon className='noColor' fontSize='small' />
          </div>
        </a>
      </div>
    </Box>
  )
}

export default TrackingKeywordUrl
